// Author : NANDHAKUMAR
// Version :0.0.1
// MODIFIED DATE: 14/11/2025
/* eslint-disable import/no-anonymous-default-export */
import businessCollectionActionTypes from './business-collection.types';
import { docodeHexResponse } from '../../../_common/common.utils';
const INITIAL_STATE = {
	getSearchBusinessLoanListStatus: null,
	getSearchBusinessLoanListResponse: null,
	getSearchBusinessLoanListArr: [],
	getBusinessLoanInfoResponse: null,
	getBusinessLoanInfoArr: [],
	updatedBusinessCollectionResponse: null,
	fetchBusinessCollectionResponse: null,
	fetchBusinessCollectionArr: [],
	revertBusinessCollectionResponse: null,
	fetchBusinessWalletArr: [],
	fetchBusinessWalletResponse: null,
	addBusinessWalletResponse: null,
	fetchBusinessQrArr: [],
	fetchBusinessQrResponse: null,
	fetchBusinessRepaymentArr: [],
	fetchBusinessRepaymentResponse: null,
	revertBusinessWalletResponse: null,
	getBusinessLoanCardPdfResponse: null,
	getBusinessLoanCardPdfArr: [],
	getBusinessRepaymentPdfResponse: null,
	getBusinessRepaymentPdfArr: [],
	getBusinessLoanCardReportResponse: null,
	getBusinessLoanCardReportArr: [],
	businessLoanCollectionApprovalResponse: null,
	businessLoanCollectionApprovalArr: [],
	getSearchBusinessSavingDetailsResponse: null,
	getSearchBusinessSavingDetailsArr: [],
	addSavingBusinessSavingDetailsResponse: null,
	updatedBusinessInterestWaiverResponse: null,
	updateBusinessLoanPaidEntryReponse: null,
	updateBusinessArrearLoanPaidEntryReponse: null,
};

export default (state = INITIAL_STATE, action: { type: any; payload: any }) => {
	switch (action.type) {
		/************************ GET SEARCH BUSINESS LOAN LIST START ****************** */
		case businessCollectionActionTypes.GET_SEARCH_BUSINESS_LOAN_LIST_SUCCESS:
			return {
				...state,
				getSearchBusinessLoanListResponse: action.payload,
				getSearchBusinessLoanListArr: docodeHexResponse(
					action.payload,
					'searchBusinessLoanListKey',
				),
			};

		case businessCollectionActionTypes.GET_SEARCH_BUSINESS_LOAN_LIST_FAILURE:
			return {
				...state,
				getSearchBusinessLoanListResponse: action.payload,
			};

		case businessCollectionActionTypes.GET_SEARCH_BUSINESS_LOAN_LIST_RESPONSE_CHANGED:
			return {
				...state,
				getSearchBusinessLoanListResponse: null,
			};
		/************************ GET SEARCH BUSINESS LOAN LIST END ****************** */

		/************************ GET SEARCH BUSINESS LOAN INFO START ****************** */
		case businessCollectionActionTypes.GET_BUSINESS_LOAN_INFO_SUCCESS:
			{
				console.log(
					'Loan Info Member',
					docodeHexResponse(action.payload, 'LoanInfoMemberLoanListKey'),
				);
			}
			return {
				...state,
				getBusinessLoanInfoResponse: action.payload,
				getBusinessLoanInfoArr: docodeHexResponse(
					action.payload,
					'LoanInfoMemberLoanListKey',
				),
			};

		case businessCollectionActionTypes.GET_BUSINESS_LOAN_INFO_FAILURE:
			return { ...state, getBusinessLoanInfoResponse: action.payload };

		case businessCollectionActionTypes.GET_BUSINESS_LOAN_INFO_RESPONSE_CHANGED:
			return { ...state, getBusinessLoanInfoResponse: null };
		/************************ GET SEARCH BUSINESS LOAN INFO END ****************** */

		/************************ UPDATE BUSINESS COLLECTION START ****************** */
		case businessCollectionActionTypes.UPDATE_BUSINESS_COLLECTION_SUCCESS:
			return { ...state, updatedBusinessCollectionResponse: action.payload };

		case businessCollectionActionTypes.UPDATE_BUSINESS_COLLECTION_FAILURE:
			return { ...state, updatedBusinessCollectionResponse: action.payload };

		case businessCollectionActionTypes.UPDATE_BUSINESS_COLLECTION_RESPONSE_CHANGED:
			return { ...state, updatedBusinessCollectionResponse: null };
		/************************  UPDATE BUSINESS COLLECTION END ****************** */

		/************************  UPDATE BUSINESS DEATH START ****************** */
		case businessCollectionActionTypes.UPDATE_BUSINESS_DEATH_SUCCESS:
			return { ...state, updatedBusinessDeathResponse: action.payload };

		case businessCollectionActionTypes.UPDATE_BUSINESS_DEATH_FAILURE:
			return { ...state, updatedBusinessDeathResponse: action.payload };

		case businessCollectionActionTypes.UPDATE_BUSINESS_DEATH_RESPONSE_CHANGED:
			return { ...state, updatedBusinessDeathResponse: null };
		/************************  UPDATE BUSINESS DEATH END ****************** */

		/************************  UPDATE INTEREST WAIVER START ****************** */
		case businessCollectionActionTypes.UPDATE_BUSINESS_INTEREST_WAIVER_SUCCESS:
			return { ...state, updatedBusinessInterestWaiverResponse: action.payload };

		case businessCollectionActionTypes.UPDATE_BUSINESS_INTEREST_WAIVER_FAILURE:
			return { ...state, updatedBusinessInterestWaiverResponse: action.payload };

		case businessCollectionActionTypes.UPDATE_BUSINESS_INTEREST_WAIVER_RESPONSE_CHANGED:
			return { ...state, updatedBusinessInterestWaiverResponse: null };
		/************************  UPDATE INTEREST WAIVER END ****************** */

		/************************  GET BUSINESS COLLECTION START ****************** */
		case businessCollectionActionTypes.GET_BUSINESS_COLLECTION_SUCCESS:
			return {
				...state,
				fetchBusinessCollectionResponse: action.payload,
				fetchBusinessCollectionArr: docodeHexResponse(
					action.payload,
					'FetchMemberCollectionDataKey',
				),
			};

		case businessCollectionActionTypes.GET_BUSINESS_COLLECTION_FAILURE:
			return { ...state, fetchBusinessCollectionResponse: action.payload };

		case businessCollectionActionTypes.GET_BUSINESS_COLLECTION_RESPONSE_CHANGED:
			return { ...state, fetchBusinessCollectionResponse: null };
		/************************  GET BUSINESS COLLECTION END ****************** */

		/************************  GET BUSINESS WALLET START ****************** */
		case businessCollectionActionTypes.GET_BUSINESS_WALLET_SUCCESS:
			return {
				...state,
				fetchBusinessWalletResponse: action.payload,
				fetchBusinessWalletArr: docodeHexResponse(
					action.payload,
					'FetchMemberWalletDataKey',
				),
			};

		case businessCollectionActionTypes.GET_BUSINESS_WALLET_FAILURE:
			return { ...state, fetchBusinessWalletResponse: action.payload };

		case businessCollectionActionTypes.GET_BUSINESS_WALLET_RESPONSE_CHANGED:
			return { ...state, fetchBusinessWalletResponse: null };
		/************************  GET BUSINESS WALLET END ****************** */

		/************************  ADD BUSINESS WALLET START ****************** */
		case businessCollectionActionTypes.ADD_BUSINESS_WALLET_SUCCESS:
			return {
				...state,
				addBusinessWalletResponse: action.payload,
			};

		case businessCollectionActionTypes.ADD_BUSINESS_WALLET_FAILURE:
			return { ...state, addBusinessWalletResponse: action.payload };

		case businessCollectionActionTypes.ADD_BUSINESS_WALLET_RESPONSE_CHANGED:
			return { ...state, addBusinessWalletResponse: null };
		/************************  ADD BUSINESS WALLET END ****************** */

		/************************  GET BUSINESS QR START ****************** */
		case businessCollectionActionTypes.GET_BUSINESS_QR_SUCCESS:
			return {
				...state,
				fetchBusinessQrResponse: action.payload,
				fetchBusinessQrArr: docodeHexResponse(action.payload, 'FetchMemberQrDataKey'),
			};

		case businessCollectionActionTypes.GET_BUSINESS_QR_FAILURE:
			return { ...state, fetchBusinessQrResponse: action.payload };

		case businessCollectionActionTypes.GET_BUSINESS_QR_RESPONSE_CHANGED:
			return { ...state, fetchBusinessQrResponse: null };
		/************************  GET BUSINESS QR END ****************** */

		/************************  GET BUSINESS REPAYMENT START ****************** */
		case businessCollectionActionTypes.GET_BUSINESS_REPAYMENT_SUCCESS:
			return {
				...state,
				fetchBusinessRepaymentResponse: action.payload,
				fetchBusinessRepaymentArr: docodeHexResponse(
					action.payload,
					'FetchMemberRepaymentDataKey',
				),
			};

		case businessCollectionActionTypes.GET_BUSINESS_REPAYMENT_FAILURE:
			return { ...state, fetchBusinessRepaymentResponse: action.payload };

		case businessCollectionActionTypes.GET_BUSINESS_REPAYMENT_RESPONSE_CHANGED:
			return { ...state, fetchBusinessRepaymentResponse: null };
		/************************  GET BUSINESS REPAYMENT END ****************** */

		/************************  DELETE BUSINESS WALLET START ****************** */
		case businessCollectionActionTypes.DELETE_BUSINESS_WALLET_SUCCESS:
			return { ...state, revertBusinessWalletResponse: action.payload };

		case businessCollectionActionTypes.DELETE_BUSINESS_WALLET_FAILURE:
			return { ...state, revertBusinessWalletResponse: action.payload };

		case businessCollectionActionTypes.DELETE_BUSINESS_WALLET_RESPONSE_CHANGED:
			return { ...state, revertBusinessWalletResponse: null };
		/************************  DELETE BUSINESS WALLET END ****************** */

		/************************  REVERT BUSINESS COLLECTION START ****************** */
		case businessCollectionActionTypes.REVERT_BUSINESS_COLLECTION_SUCCESS:
			return { ...state, revertBusinessCollectionResponse: action.payload };

		case businessCollectionActionTypes.REVERT_BUSINESS_COLLECTION_FAILURE:
			return { ...state, revertBusinessCollectionResponse: action.payload };

		case businessCollectionActionTypes.REVERT_BUSINESS_COLLECTION_RESPONSE_CHANGED:
			return { ...state, revertBusinessCollectionResponse: null };
		/************************  REVERT BUSINESS COLLECTION END ****************** */

		/***************** BUSINESS LOAN CARD PDF START ***********************/
		case businessCollectionActionTypes.BUSINESS_LOAN_CARD_PDF_FAILURE:
			return {
				...state,
				getBusinessLoanCardPdfResponse: 'Failure',
			};

		case businessCollectionActionTypes.BUSINESS_LOAN_CARD_PDF_RESPONSE_CHANGED:
			return { ...state, getBusinessLoanCardPdfResponse: null };

		case businessCollectionActionTypes.BUSINESS_LOAN_CARD_PDF_SUCCESS:
			return {
				...state,
				getBusinessLoanCardPdfResponse: 'Success',
				getBusinessLoanCardPdfArr: action.payload,
			};

		/*****************  BUSINESS LOAN CARD PDF END ***********************/

		/***************** BUSINESS REPAYMENT PDF START ***********************/
		case businessCollectionActionTypes.BUSINESS_REPAYMENT_PDF_FAILURE:
			return {
				...state,
				getBusinessRepaymentPdfResponse: 'Failure',
			};

		case businessCollectionActionTypes.BUSINESS_REPAYMENT_PDF_RESPONSE_CHANGED:
			return { ...state, getBusinessRepaymentPdfResponse: null };

		case businessCollectionActionTypes.BUSINESS_REPAYMENT_PDF_SUCCESS:
			return {
				...state,
				getBusinessRepaymentPdfResponse: 'Success',
				getBusinessRepaymentPdfArr: action.payload,
			};

		/*****************  BUSINESS REPAYMENT PDF END ***********************/

		/***************** BUSINESS LOAN CARD REPORT START ***********************/
		case businessCollectionActionTypes.BUSINESS_LOAN_CARD_REPORT_FAILURE:
			return {
				...state,
				getBusinessLoanCardReportResponse: 'Failure',
			};

		case businessCollectionActionTypes.BUSINESS_LOAN_CARD_REPORT_RESPONSE_CHANGED:
			return { ...state, getBusinessLoanCardReportResponse: null };

		case businessCollectionActionTypes.BUSINESS_LOAN_CARD_REPORT_SUCCESS:
			return {
				...state,
				getBusinessLoanCardReportResponse: 'Success',
				getBusinessLoanCardReportArr: action.payload,
			};

		/*****************  BUSINESS LOAN CARD REPORT END ***********************/

		/***************** BUSINESS LOAN COLLECTION APPROVAL START ***********************/
		case businessCollectionActionTypes.BUSINESS_LOAN_COLLECTION_APPROVAL_FAILURE:
			return {
				...state,
				businessLoanCollectionApprovalResponse: 'Failure',
			};

		case businessCollectionActionTypes.BUSINESS_LOAN_COLLECTION_APPROVAL_RESPONSE_CHANGED:
			return { ...state, businessLoanCollectionApprovalResponse: null };

		case businessCollectionActionTypes.BUSINESS_LOAN_COLLECTION_APPROVAL_SUCCESS:
			return {
				...state,
				businessLoanCollectionApprovalResponse: action.payload,
				businessLoanCollectionApprovalArr: action.payload,
			};

		/***************** BUSINESS LOAN COLLECTION APPROVAL START ***********************/
		case businessCollectionActionTypes.BUSINESS_COLLECTION_LOAN_PAID_ENTRY_FAILURE:
			return {
				...state,
				updateBusinessLoanPaidEntryReponse: action.payload,
			};

		case businessCollectionActionTypes.BUSINESS_COLLECTION_LOAN_PAID_ENTRY_RESPONSE_CHANGED:
			return { ...state, updateBusinessLoanPaidEntryReponse: null };

		case businessCollectionActionTypes.BUSINESS_COLLECTION_LOAN_PAID_ENTRY_SUCCESS:
			return {
				...state,
				updateBusinessLoanPaidEntryReponse: action.payload,
			};

		/*****************  BUSINESS LOAN COLLECTION APPROVAL END ***********************/

		/***************** BUSINESS LOAN COLLECTION ARREAR ENTRY START ***********************/
		case businessCollectionActionTypes.BUSINESS_COLLECTION_LOAN_PAID_ARREAR_ENTRY_FAILURE:
			return {
				...state,
				updateBusinessArrearLoanPaidEntryReponse: action.payload,
			};

		case businessCollectionActionTypes.BUSINESS_COLLECTION_LOAN_PAID_ARREAR_ENTRY_RESPONSE_CHANGED:
			return { ...state, updateBusinessArrearLoanPaidEntryReponse: null };

		case businessCollectionActionTypes.BUSINESS_COLLECTION_LOAN_PAID_ARREAR_ENTRY_SUCCESS:
			return {
				...state,
				updateBusinessArrearLoanPaidEntryReponse: action.payload,
			};

		/*****************  BUSINESS LOAN COLLECTION ARREAR ENTRY END ***********************/

		default:
			return state;
	}
};
